import { Badge, Button } from '@mantine/core';
import { IconCircleCheckFilled, IconClockHour4 } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';
import { trackFinancesComingSoonInterested } from 'src/Services/Mixpanel/events';
import { getCcaVocabKey } from 'src/Utils/legalStructureVocabulary';

import styles from './PartnerCurrentAccountPreview.module.scss';

const PartnerCurrentAccountPreview = () => {
  const { t } = useTranslation();
  const { data: asset } = useFetchAssetDetails();
  const [interested, setInterested] = useState(false);

  const vocabKey = getCcaVocabKey(asset?.legalStructure);

  const handleInterested = () => {
    if (interested) return;
    setInterested(true);
    trackFinancesComingSoonInterested({ feature: 'partner_current_account' });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Badge variant="light" color="gray" size="lg" leftSection={<IconClockHour4 size={14} />}>
          {t('expenses.home.comingSoon', 'Bientôt disponible')}
        </Badge>
        <h3 className={styles.title}>{t(`cca.title.${vocabKey}`)}</h3>
        <p className={styles.subtitle}>{t(`cca.subtitle.${vocabKey}`)}</p>
      </div>

      <div className={styles.story}>
        <div className={styles.storyLabel}>
          {t('cca.story.title', 'Un exemple concret : la tempête')}
        </div>
        <p className={styles.storyBody}>{t('cca.story.body')}</p>
      </div>

      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          <IconCircleCheckFilled size={20} className={styles.benefitIcon} />
          <span>{t('cca.benefit.1')}</span>
        </li>
        <li className={styles.benefit}>
          <IconCircleCheckFilled size={20} className={styles.benefitIcon} />
          <span>{t('cca.benefit.2')}</span>
        </li>
        <li className={styles.benefit}>
          <IconCircleCheckFilled size={20} className={styles.benefitIcon} />
          <span>{t('cca.benefit.3')}</span>
        </li>
      </ul>

      <div className={styles.footer}>
        {interested ? (
          <span className={styles.thanks}>
            {t('comingSoon.thanks', 'Merci ! On vous tient au courant.')}
          </span>
        ) : (
          <Button variant="outline" onClick={handleInterested}>
            {t('comingSoon.interested', "Ça m'intéresse")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PartnerCurrentAccountPreview;
